<template>
  <b-navbar-nav>
    <b-nav-item
      v-if="permissions.isAdminAndAbove && permissions.isUsePurchase"
      class="d-block d-lg-none"
      :href="$appConfig.ScreenUrl.purchaseOrderList"
      @click="onClickNavItem($appConfig.serviceID.purchase)"
    >
      {{ $t('受発注管理') }}
    </b-nav-item>
    <b-nav-item
      v-if="permissions.isUseInventory"
      class="d-block d-lg-none"
      :href="$appConfig.ScreenUrl.ship"
      @click="onClickNavItem($appConfig.serviceID.inventory)"
    >
      {{ $t('在庫管理') }}
    </b-nav-item>
    <b-nav-item
      v-if="permissions.isUseSmallLot"
      class="d-block d-lg-none"
      :href="$appConfig.ScreenUrl.scheduleOrder"
      @click="onClickNavItem($appConfig.serviceID.smallLot)"
    >
      {{ $t('工程管理') }}
    </b-nav-item>
    <b-nav-item
      v-if="permissions.isMasterAdminAndAbove"
      class="d-block d-lg-none"
      :href="$appConfig.ScreenUrl.settingMenu"
      @click="onClickNavItem($appConfig.serviceID.base)"
    >
      {{ $t('各種設定') }}
    </b-nav-item>
  </b-navbar-nav>
</template>

<script>
export default {
  props: {
    /** サービスの使用権限を取得する関数群 */
    permissions: {
      type: Object,
      required: true,
    },
  },
  methods: {
    /** ナビゲーションアイテムをクリック時の処理 */
    onClickNavItem(serviceID) {
      this.$emit('onClickNavItem', serviceID)
    },
  },
}
</script>

<style lang="scss" scoped></style>
